/* eslint-disable max-len */
import React, { useState } from "react";

export default function CustomErrorPopup({ handleClose, fileName, error_index, invalidHeader }) {

    function stringToRowFormat(string) {
        // Split the input string into an array of numbers
        const numbers = string.split(",").map(Number);
        const last_number = numbers.pop();

        if(numbers.length === 0){
            return `Row ${last_number}`;
        }

        // Join the formatted numbers with commas and spaces
        const joinedNumbers = numbers.join(", ");

        // Add "and" before the last number
        return `Row ${joinedNumbers} and ${last_number}`;
    }


    return (
        <div className="w-auto flex">
            <div className="p-[4px] w-full bg-white relative">
                <div className={`flex justify-between pb-4`}>
                    <h1 className="text-lg font-medium text-[#1f1f1f]">
                        File Upload Status
                    </h1>
                    <div className="flex flex-shrink-0 justify-center items-start rounded-t-md">
                        {/* <!--Close button--> */}
                        <button
                            onClick={() => handleClose()}
                            type="button"
                            className="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                            data-te-modal-dismiss=""
                            aria-label="Close"
                        >
                            <img loading="lazy" decoding="async" src="/assets/images/close-icon.svg" alt="icon" />
                        </button>
                    </div>
                </div>
                <div className="pr-3 breakword text-[14px] leading-[22px] text-[#4B4B4B] flex flex-col gap-2">
                    <h1 className="font-bold">
                        Partial records added.
                    </h1>
                    <div>
                        <h1 className="font-bold">
                            File uploaded:
                        </h1>
                        <p className="font-normal">
                            {fileName}
                        </p>
                    </div>
                    <div>
                        <h1 className="font-bold">
                            {invalidHeader}
                        </h1>
                        <p className="font-normal">
                            {stringToRowFormat(error_index)}
                        </p>
                    </div>
                </div>

                <div className="flex justify-end space-x-2 mt-6">
                    <button
                        onClick={handleClose}
                        className="px-4 py-[10px] bg-primary text-white rounded-[12px] flex items-center justify-center h-[40px] relative"
                        type="submit"
                        data-testid="okay-btn"
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
}
